import React, { useEffect, useState } from 'react';
import { getFromSessionStorage, getUserNameFor, setInSessionStorage, stopBackgroundScrolling } from '../../../common/utils/app.utils';
import NeedAssistantPopup from './need-assistant-popup';
import { addDiConnectionDetails, submitNeedAssistance } from '../../../common/helper/api.helper';
import CustomerMessageCard from '../customerMessageCard/customerMessageCard';
import {
  CUSTOMER_DETAIL,
  DEDICATED_CUSTOMER_DETAIL,
  DEDICATED_FEASIBILITY_RESPONSE,
  FEASIBILITY_RESPONSE,
  FETCH_SUCCESS,
  INITIATE_FETCHING,
  LEAD_STATUS,
  LEAD_STATUS_MSG,
  MODULE_ID
} from '../../../home/common/constants/constants';
import Button from 'b2b-ui-components-lib/lib/components/button';
import './need-assistant.scss';
import '../kam-price-negotation/kamPriceNegotation';
import { faOnDedicatedNeedAssistance, faOnDedicatedNeedAssistancePopupSuccess } from '../../services/analytics.service';
import KamPriceNegotation from '../kam-price-negotation/kamPriceNegotation';
import { MEDIA_TYPES } from 'dedicated/components/choose-plan/plan.service';

const NeedAssistant = ({
  selectedIpAttributes,
  ipAttributeType,
  checkLeadSatus,
  leadStatus,
  kamDetails,
  selectedPlan,
  contractPeriod,
  fetchLead,
  leadDetails,
  setAPIFetechingState,
  selectedRouter,
  selectedPrimaryMedia = {},
  itemCode,
  selectedRateCardId
}) => {
  let [remarksValue, setRemarksValue] = useState('');
  let [btnDisabled, setBtnDisabled] = useState(false);
  const [showNeedAssistantPopup, setShowNeedAssistantPopup] = useState(false);

  const closeNeedAssistantPopup = () => {
    stopBackgroundScrolling(false);
    setShowNeedAssistantPopup(false);
  };
  const submitNeedAssistanceData = () => {
    setBtnDisabled(true);
    let payLoad = {};
    payLoad.remarks = remarksValue;
    submitNeedAssistance(payLoad, true)
      .then((response) => {
        let data = response && response.data && response.data.result;
        setBtnDisabled(false);
        fetchLead();
        faOnDedicatedNeedAssistancePopupSuccess();
      })
      .catch((err) => {
        setBtnDisabled(false);
        setAPIFetechingState({ type: FETCH_SUCCESS });
      });
    closeNeedAssistantPopup();
  };

  const needAssistant = () => {
    if (selectedPlan && selectedPlan.price && selectedPlan.price.amount === 0) {
      submitAddDiConnectionDetails();
    } else {
      stopBackgroundScrolling(true);
      setShowNeedAssistantPopup(true);
      faOnDedicatedNeedAssistance();
    }
  };
  const submitAddDiConnectionDetails = () => {
    setAPIFetechingState({ type: INITIATE_FETCHING });
    let feasibilityResponse = getFromSessionStorage(MODULE_ID, DEDICATED_FEASIBILITY_RESPONSE);
    let connectionDetails = getFromSessionStorage(MODULE_ID, DEDICATED_CUSTOMER_DETAIL)
      ? getFromSessionStorage(MODULE_ID, DEDICATED_CUSTOMER_DETAIL)
      : leadDetails && leadDetails.connectivityLineItems;
    let payLoad = {};
    if (selectedPlan && selectedPlan.service === 'UNMANAGED') {
      selectedPlan.routerSpecs = null;
    } else if (selectedPlan && selectedPlan.id >= 0 && selectedPlan.service === 'MANAGED') {
      selectedPlan.routerSpecs = selectedRouter && selectedRouter[selectedPlan.id] && [selectedRouter[selectedPlan.id]];
    }
    let getSelectedIpAttributes = selectedIpAttributes;
    let newplan = { ...selectedPlan, planPeriod: contractPeriod && contractPeriod.value * 12 };
    if (newplan && Object.keys(newplan.specs).length > 1) {
      newplan.specs = newplan.specs;
    } else if (getSelectedIpAttributes && getSelectedIpAttributes.length > 0) {
      newplan.specs = getSelectedIpAttributes;
    }

    if (selectedRateCardId?.key) {
      newplan['rateCardId'] = selectedRateCardId?.key;
    }

    // set itemCode in payload
    if (Array.isArray(newplan?.routerSpecs) && newplan?.routerSpecs?.length > 0 && itemCode) {
      newplan?.routerSpecs?.map((item) => {
        if (item['make'] && item['model']) {
          item['itemCode'] = itemCode;
        }
      });
    }

    let feasibilityId = leadDetails && leadDetails.feasibilityId ? leadDetails.feasibilityId : feasibilityResponse && feasibilityResponse.feasibilityId;
    let feasibilityStatus = leadDetails && leadDetails.feasibilityStatus ? leadDetails.feasibilityStatus : feasibilityResponse && feasibilityResponse.feasibilityStatus;
    payLoad = { planDetail: newplan, feasibilityId: feasibilityId, feasibilityStatus: feasibilityStatus, ...connectionDetails };
    addDiConnectionDetails([payLoad])
      .then((response) => {
        if (selectedPlan && selectedPlan.price && selectedPlan.price.amount === 0) {
          fetchLead();
          faOnDedicatedNeedAssistancePopupSuccess();
        } else {
          submitNeedAssistanceData();
        }
      })
      .catch((err) => {
        setAPIFetechingState({ type: FETCH_SUCCESS });
        console.error(err);
      });
  };

  const isSelectedMediaTPorOffnet = () => {
    let isMediaTpOrOffnet = false;
    const selectedMedia = (selectedPrimaryMedia && Object.keys(selectedPrimaryMedia).length > 0 && selectedPrimaryMedia.key) || '';

    if (selectedMedia && (selectedMedia === MEDIA_TYPES.OFFNET || selectedMedia === MEDIA_TYPES.THIRD_PARTY)) {
      isMediaTpOrOffnet = true;
    }

    return isMediaTpOrOffnet;
  };

  return (
    <div className="needAssistance">
      <div className="contact_details">
        <div className="accordion-card">
          <div className="accordion-content">
            {kamDetails && kamDetails.firstName && kamDetails.email && kamDetails.phoneNumber && (
              <React.Fragment>
                <div className="contact_info">
                  <div className="account_icon">{kamDetails.firstName && getUserNameFor(kamDetails.firstName)}</div>
                  <div className="assist_detail">
                    <div className="inset_details">
                      <h6>Contact Your Account Manager</h6>
                      <ul className="contact_types">
                        <li>{kamDetails.firstName}</li>
                        <li>
                          <a href={`mailto:${kamDetails.email}`}>{kamDetails.email}</a>
                        </li>
                        <li>+91 {kamDetails.phoneNumber}</li>
                      </ul>
                    </div>
                    <div className="assist_action">
                      {selectedPlan && Object.keys(selectedPlan).length > 0 && selectedPlan.price && !checkLeadSatus() && !ipAttributeType && !isSelectedMediaTPorOffnet() ? (
                        <Button onClick={needAssistant}>Need Assistance</Button>
                      ) : (
                        <Button disabled>Need Assistance</Button>
                      )}
                    </div>
                  </div>
                </div>
                {leadDetails && leadDetails.customerRemarks && <CustomerMessageCard customerRemarks={leadDetails.customerRemarks} />}
              </React.Fragment>
            )}
          </div>
          {leadStatus === LEAD_STATUS.FEASIBILITY_PENDING && leadDetails && (
            <div className="accordion-footer">
              <div className="info_strip">
                <span className="material-icons">check_circle</span>
                <div className="info_text">Status: {leadDetails.needAssistance ? LEAD_STATUS_MSG.FEASIBILITY_PENDING : LEAD_STATUS_MSG.FEASIBILITY_PENDING}</div>
              </div>
            </div>
          )}
        </div>
      </div>
      {showNeedAssistantPopup && (
        <NeedAssistantPopup
          closeNeedAssistantPopup={closeNeedAssistantPopup}
          setRemarksValue={setRemarksValue}
          remarksValue={remarksValue}
          submitAddDiConnectionDetails={submitAddDiConnectionDetails}
          btnDisabled={btnDisabled}
        />
      )}
    </div>
  );
};
export default NeedAssistant;
